
import Hero from "../components/Hero";
import AboutUs from "../components/AboutUs";
import Services from "../components/Services";
import WhyChooseUs from "../components/WhyChooseUs";
import GallerySection from "../components/GallerySection";
import TestimonialsSection from "../components/TestimonialSection";
import CTA from "../components/CTA";
import PerfectForSection from "../components/PerfectForSection";
import PricingSection from "../components/PricingSection";
import ContactSection from "../components/ContactSection";
// import HowItWorks from "../../components/root/HowItWorks";
// import HumanExpertise from "../../components/root/HumanExpertise";
// import Testimonials from "../../components/root/Testimonials";
// import backgroundImage from "../../assets/new images/Background.png";
// import img1 from "../../assets/new images/howitworks1.png";
// import img2 from "../../assets/new images/howitworks2.png";
// import img3 from "../../assets/new images/howitworks3.png";
const Home = () => {
//   const steps = [
//   {
//     img: img1,
//     title: "Create Your Profile",
//     desc: "Tell us about your background, goals, and interests.",
//   },
//   {
//     img: img2,
//     title: "Match with Mentors or AI Coach",
//     desc: "Instantly connect with an expert or explore AI insights.",
//   },
//   {
//     img: img3,
//     title: "Grow with Guided Learning",
//     desc: "Follow personalized career roadmaps and skill development plans.",
//   },
// ];
  return (
    <div className="font-sans overflow-x-hidden">

      <Hero/>
      <AboutUs/>
      <Services/>
      <WhyChooseUs/>
      <PerfectForSection />
      <GallerySection/>
      <PricingSection /> 
      <TestimonialsSection/>
      {/* <CTA/> */}
      <ContactSection />  

      {/* <WhyCabil />
        <HowItWorks
      title="How It Works"
      subtitle="Getting started with Cabil is simple and straightforward"
      steps={steps}
      accentColor="#EE5F2B"  // matches your brand orange
    />
      <HumanExpertise />
      <Testimonials /> */}

    </div>
  );
};

export default Home;
